<template>
  <div class="comfortable-credit-info">
    <h2 class="title fn-title-1">Овердрафт</h2>

    <p class="m-body-m description">
      Кредит без застави на термінові платежі на поповнення обігових коштів при нестачі власних коштів на рахунку.
      Надається у вигляді овердрафту на рахунок від 0% річних з умовою обнулення до 90 днів та з можливістю зняття готівкою.
    </p>

    <ul class="tabs">
      <li class="item m-body-sb" :class="{ active: typeLocal === 'flp' }" v-on:click="checkType('flp')">Підприємець</li>
      <li class="item m-body-sb" :class="{ active: typeLocal === 'jur' }" v-on:click="checkType('jur')">Юридична особа</li>
    </ul>

    <div v-if="typeLocal === 'flp'" class="tab-content tab-content-flp">
      <h4 class="content-title m-body-sb">Умови:</h4>

      <div class="row">
        <div class="column row-title m-body-m">Ліміт овердрафту</div>
        <div class="column row-value m-body-b">до 40% від надходжень</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за встановлення</div>
        <div class="column row-value m-body-b">0,5% (разово)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за зняття готівкою</div>
        <div class="column row-value m-body-b">3%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Період обнулення</div>
        <div class="column row-value m-body-b">до 90 днів</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Погашення</div>
        <div class="column row-value m-body-b">автоматично при надходженні коштів на рахунок</div>
      </div>

      <div class="annual-rate-block">
        <div class="row-title m-body-m w100">Річна % ставка в залежності від кількості днів безперервного використання:</div>
        <div class="annual-rate">
          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">1 день</div>
            <div class="annual-rate-value m-body-b">0%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">2 - 3 дні</div>
            <div class="annual-rate-value m-body-b">19%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">4 - 7 днів</div>
            <div class="annual-rate-value m-body-b">23%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">8 - 15 днів</div>
            <div class="annual-rate-value m-body-b">27%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">16 - 30 днів</div>
            <div class="annual-rate-value m-body-b">30%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">31 - 60 днів</div>
            <div class="annual-rate-value m-body-b">33%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">61 - 90 днів</div>
            <div class="annual-rate-value m-body-b">35%</div>
          </div>
        </div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          декларація про доходи за останній звітній період (не меньш ніж за півроку)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками ФОП свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          ОСВ по рахунках 28, 36, 63, 68, 70 за останні 12 місяців
        </div>
      </div>
    </div>

    <div v-if="typeLocal === 'jur'" class="tab-content tab-content-flp">
      <h4 class="content-title m-body-sb">Умови:</h4>

      <div class="row">
        <div class="column row-title m-body-m">Ліміт овердрафту</div>
        <div class="column row-value m-body-b">до 40% від надходжень</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за встановлення</div>
        <div class="column row-value m-body-b">0,5% (разово)</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Комісія за зняття готівкою</div>
        <div class="column row-value m-body-b">3%</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Період обнулення</div>
        <div class="column row-value m-body-b">до 90 днів</div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m">Погашення</div>
        <div class="column row-value m-body-b">автоматично при надходженні коштів на рахунок</div>
      </div>

      <div class="annual-rate-block">
        <div class="row-title m-body-m w100">Річна % ставка в залежності від кількості днів безперервного використання:</div>
        <div class="annual-rate">
          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">1 день</div>
            <div class="annual-rate-value m-body-b">0%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">2 - 3 дні</div>
            <div class="annual-rate-value m-body-b">19%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">4 - 7 днів</div>
            <div class="annual-rate-value m-body-b">23%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">8 - 15 днів</div>
            <div class="annual-rate-value m-body-b">27%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">16 - 30 днів</div>
            <div class="annual-rate-value m-body-b">30%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">31 - 60 днів</div>
            <div class="annual-rate-value m-body-b">33%</div>
          </div>

          <div class="annual-rate-row">
            <div class="annual-rate-title m-body-m">61 - 90 днів</div>
            <div class="annual-rate-value m-body-b">35%</div>
          </div>
        </div>
      </div>

      <h4 class="content-title m-body-sb">Документи для заявки:</h4>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фінансова звітність за останній звітний рік
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          виписка за рахунками свого банку з детальним розшифруванням рухів коштів за останні 12 міс.
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)
        </div>
      </div>

      <div class="row">
        <div class="column row-title m-body-m w100">
          ОСВ по рахунках 28, 36, 63, 68, 70 за останні 12 місяців
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      default: 'flp'
    }
  },
  data: function () {
    return {
      typeLocal: ''
    }
  },
  methods: {
    checkType: function (type) {
      this.typeLocal = type
      this.$emit('update:type', type)
    }
  },
  watch: {
    type: {
      immediate: true,
      handler (val) {
        this.typeLocal = val
      }
    }
  }
}

</script>

<style scoped lang="less">
.comfortable-credit-info {
  text-align: left;

  .title {
    margin: 0 0 16px 0;
    color: var(--black);
  }

  .description {
    margin: 0 0 36px 0;
    color: var(--black);
  }

  .tab-content {
    margin: 42px 0 0 0;

    .content-title {
      margin: 0 0 8px 0;
      color: var(--grey-140)
    }

    .row {
      display: flex;
      align-items: center;
      padding: 12px 0;
      border-top: 1px solid var(--grey-240);

      .column {
        width: 50%;
      }

      .row-title {
        position: relative;
        padding: 0 0 0 24px;
        color: var(--black);

        &:before {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: var(--second-base);
        }
      }

      .row-value {
        display: flex;
        color: var(--black);

        .third {
          width: 33%;
        }
      }
    }

    .row + .content-title {
      margin: 52px 0 8px 0;
    }

    .annual-rate-block {
      display: flex;
      flex-direction: column;
      padding: 12px 0;
      border-top: 1px solid var(--grey-240);

      .row-title {
        position: relative;
        padding: 0 0 0 24px;
        &:before {
          content: '';
          position: absolute;
          top: 7px;
          left: 8px;
          width: 8px;
          height: 8px;
          border-radius: 100%;
          background: var(--second-base);
        }
      }

      .annual-rate {
        margin: 15px 0;
        padding: 0 0 0 24px;
      }

      .annual-rate-row {
        display: flex;
        margin: 0 0 5px 0;

        .annual-rate-title {
          width: 30%;
        }
      }
    }
  }
}
</style>
